import { normalizeListing, AlgoliaListing } from '@ha/algolia';
import { SearchResponse } from '@algolia/client-search';
import { CitiesSummary } from '@ha/api/v2/types/ListingsSummary';

import { ListingsGroup } from '../types';

const getGroupedListings = (
  results: SearchResponse<AlgoliaListing>[],
  citiesSummary: CitiesSummary[],
  isImperialSystem: boolean,
): ListingsGroup[] => {
  let groupedListingsByCity: ListingsGroup[] = [];

  const normalize = normalizeListing({ currency: 'EUR', currencyRate: 1 });

  if (results.length) {
    groupedListingsByCity = results
      .filter(group => group.hits.length)
      .map(group => {
        const { city, country } = group.hits[0];

        const cityLocalized = citiesSummary.find(
          summary => summary.city === city,
        )?.cityLocalized;
        const countryLocalized = citiesSummary.find(
          summary => summary.country === country,
        )?.countryLocalized;

        return {
          city,
          cityLocalized,
          country,
          countryLocalized,
          isImperialSystem,
          totalListings: group.nbHits,
          listings: group.hits.map(listing => normalize(listing)),
        };
      });
  }

  return groupedListingsByCity;
};
export { getGroupedListings };
